import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import HomeHeroStudents from '../../../assets/images/PoweredByDQ/HomeHeroStudents.jpg';
import HomeHeroDqLogo from '../../../assets/images/PoweredByDQ/HomeHeroDqLogo.png';
import { sdsColors } from '../theme/solutionsDesignSystem';

const useStyles = makeStyles(() => ({
    heroArt: {
        position: 'relative',
        flex: '1 1 440px',
        minWidth: 0,
        minHeight: 520,
        '@media (max-width: 960px)': {
            minHeight: 460,
            width: '100%',
        },
    },
    heroPhoto: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 56,
        left: '14%',
        borderRadius: 28,
        overflow: 'hidden',
        background: '#172939',
        '@media (max-width: 960px)': {
            left: '6%',
        },
    },
    heroPhotoImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: '55% 40%',
        display: 'block',
        filter: 'saturate(0.78) contrast(1.04)',
    },
    photoGradient: {
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(160deg, rgba(23,41,57,0.55) 0%, rgba(23,41,57,0.18) 45%, rgba(23,41,57,0) 70%), linear-gradient(0deg, rgba(23,41,57,0.45) 0%, rgba(23,41,57,0) 40%)',
    },
    circleOverlay1: {
        position: 'absolute',
        inset: 'auto -10% -30% 30%',
        height: '70%',
        borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.35)',
        pointerEvents: 'none',
    },
    circleOverlay2: {
        position: 'absolute',
        inset: '-20% -20% auto 45%',
        height: '70%',
        borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.25)',
        pointerEvents: 'none',
    },
    heroCard: {
        position: 'absolute',
        left: 0,
        right: '10%',
        bottom: 0,
        display: 'flex',
        background: sdsColors.surface,
        borderRadius: 20,
        boxShadow: '0 30px 80px rgba(23,41,57,0.18), 0 2px 6px rgba(23,41,57,0.06)',
        overflow: 'hidden',
        border: '1px solid rgba(23,41,57,0.06)',
        zIndex: 2,
        '@media (max-width: 600px)': {
            right: 0,
        },
    },
    sidebar: {
        width: 56,
        flex: 'none',
        padding: '16px 8px',
        borderRight: '1px solid #EEF1F4',
        background: '#FAFBFC',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    sidebarLogoWrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px 0 14px',
    },
    sidebarLogo: {
        height: 18,
        width: 'auto',
        display: 'block',
    },
    sidebarItemActive: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '10px 0',
        justifyContent: 'center',
        borderRadius: 8,
        background: '#E8F1FB',
        color: '#2456A4',
    },
    sidebarItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '10px 0',
        justifyContent: 'center',
        borderRadius: 8,
        color: '#5B6470',
    },
    cardContent: {
        flex: 1,
        minWidth: 0,
        padding: '18px 18px 16px',
        display: 'grid',
        gap: 14,
        background: sdsColors.surface,
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
    },
    cardTitle: {
        fontSize: 14,
        fontWeight: 700,
        color: sdsColors.text,
    },
    globalDropdown: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 11.5,
        fontWeight: 600,
        padding: '6px 10px',
        border: '1px solid #E1E4E9',
        borderRadius: 8,
        color: '#1B2430',
        background: '#FFFFFF',
    },
    statsRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 160px), 1fr))',
        gap: 14,
    },
    gaugeBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: 12,
        border: '1px solid #EEF1F4',
        borderRadius: 14,
        minWidth: 0,
    },
    areasBox: {
        display: 'grid',
        gap: 7,
        alignContent: 'center',
        fontSize: 10.5,
        color: '#5B6470',
    },
    areaRow: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1.2fr) minmax(0, 1fr) 22px',
        gap: 8,
        alignItems: 'center',
    },
    areaName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    areaTrack: {
        height: 4,
        background: '#EEF1F4',
        borderRadius: 2,
        position: 'relative',
        overflow: 'hidden',
    },
    areaFill: {
        position: 'absolute',
        inset: '0 auto 0 0',
        borderRadius: 2,
    },
    areaScore: {
        textAlign: 'right',
        fontWeight: 700,
        color: '#1B2430',
        fontVariantNumeric: 'tabular-nums',
    },
    bottomRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 160px), 1fr))',
        gap: 14,
    },
    benchmarkCard: {
        padding: 12,
        border: '1px solid #EEF1F4',
        borderRadius: 14,
        display: 'grid',
        gap: 10,
        minWidth: 0,
    },
    benchmarkTitle: {
        fontSize: 11.5,
        fontWeight: 700,
        color: '#1B2430',
    },
    benchmarkPlot: {
        height: 54,
        borderRadius: 8,
        backgroundColor: '#F4F7FB',
        backgroundImage: 'radial-gradient(#C9D6E6 0.9px, transparent 1px)',
        backgroundSize: '7px 7px',
        position: 'relative',
    },
    plotDot: {
        position: 'absolute',
        width: 7,
        height: 7,
        borderRadius: '50%',
        background: '#3C84D2',
        boxShadow: '0 0 0 3px rgba(60,132,210,0.18)',
    },
    benchmarkLegend: {
        display: 'grid',
        gap: 4,
        fontSize: 10,
        color: '#5B6470',
        fontVariantNumeric: 'tabular-nums',
    },
    legendItem: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 8,
    },
    legendLabel: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
    },
    legendDot: {
        width: 6,
        height: 6,
        borderRadius: '50%',
    },
    impactCard: {
        padding: 12,
        border: '1px solid #EEF1F4',
        borderRadius: 14,
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        gap: 10,
        alignItems: 'end',
    },
    impactLeft: {
        display: 'grid',
        gap: 10,
    },
    impactTitle: {
        fontSize: 11.5,
        fontWeight: 700,
        color: '#1B2430',
    },
    impactBars: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: 5,
        height: 64,
    },
    impactRight: {
        textAlign: 'right',
    },
    impactMuted: {
        display: 'block',
        fontSize: 10,
        color: '#5B6470',
    },
    impactValue: {
        display: 'block',
        fontSize: 24,
        fontWeight: 800,
        letterSpacing: '-0.02em',
        lineHeight: 1,
        color: '#1B2430',
        marginTop: 2,
        fontVariantNumeric: 'tabular-nums',
    },
}));

const SPECTRUM = ['#68C3EE', '#BCD253', '#EDB459', '#ED6628', '#B9316D', '#718DC4'];
const RADIUS = 48;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS; // ~301.59
const SEGMENT = CIRCUMFERENCE / 6;           // ~50.27
const GAP = 3;

const RING_DATA = SPECTRUM.map((color, i) => ({
    color,
    dash: `${(SEGMENT - GAP).toFixed(2)} ${(CIRCUMFERENCE - SEGMENT + GAP).toFixed(2)}`,
    rotate: `rotate(${-90 + i * 60} 60 60)`,
}));

const AREAS = [
    { name: 'Digital Citizenship', value: 78, color: SPECTRUM[0] },
    { name: 'Safety & Wellbeing', value: 68, color: SPECTRUM[1] },
    { name: 'Learning & Creativity', value: 71, color: SPECTRUM[2] },
    { name: 'Media & Information', value: 66, color: SPECTRUM[3] },
    { name: 'Career & Work', value: 62, color: SPECTRUM[4] },
    { name: 'Society & Participation', value: 74, color: SPECTRUM[5] },
];

const BENCHMARK_ITEMS = [
    { label: 'Global Average', score: '58', color: '#B9316D' },
    { label: 'Top 20%', score: '76', color: '#68C3EE' },
    { label: 'Your Country', score: '72', color: '#BCD253' },
];

const PbdqHeroDashboardCard = () => {
    const classes = useStyles();

    return (
        <div className={classes.heroArt} data-hero-art="">
            <div className={classes.heroPhoto} data-hero-photo="">
                <img
                    src={HomeHeroStudents}
                    alt="Students working on laptops while a teacher supervises"
                    className={classes.heroPhotoImage}
                />
                <div aria-hidden="true" className={classes.photoGradient} />
                <div aria-hidden="true" className={classes.circleOverlay1} />
                <div aria-hidden="true" className={classes.circleOverlay2} />
            </div>

            <div
                className={classes.heroCard}
                data-hero-card=""
                role="img"
                aria-label="Powered by DQ dashboard: overall capability 72 of 100 with capability by area, global benchmark and program impact"
            >
                <aside aria-label="Dashboard navigation" className={classes.sidebar}>
                    <div className={classes.sidebarLogoWrap}>
                        <img src={HomeHeroDqLogo} alt="" className={classes.sidebarLogo} />
                    </div>
                    <span className={classes.sidebarItemActive}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <rect x="3" y="3" width="7" height="7" rx="1.5" />
                            <rect x="14" y="3" width="7" height="7" rx="1.5" />
                            <rect x="3" y="14" width="7" height="7" rx="1.5" />
                            <rect x="14" y="14" width="7" height="7" rx="1.5" />
                        </svg>
                    </span>
                    <span className={classes.sidebarItem}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <path d="M9 11l3 3 8-8" />
                            <path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9" />
                        </svg>
                    </span>
                    <span className={classes.sidebarItem}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <rect x="3" y="4" width="18" height="16" rx="2" />
                            <path d="M3 10h18" />
                        </svg>
                    </span>
                    <span className={classes.sidebarItem}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <path d="M4 20V10" />
                            <path d="M10 20V4" />
                            <path d="M16 20v-7" />
                            <path d="M22 20H2" />
                        </svg>
                    </span>
                    <span className={classes.sidebarItem}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <circle cx="12" cy="12" r="9" />
                            <path d="M3 12h18" />
                            <path d="M12 3a14 14 0 0 1 0 18" />
                        </svg>
                    </span>
                    <span className={classes.sidebarItem}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
                            <path d="M14 3v6h6" />
                        </svg>
                    </span>
                </aside>

                <div className={classes.cardContent}>
                    <div className={classes.cardHeader}>
                        <span className={classes.cardTitle}>AI-digital capability</span>
                        <span className={classes.globalDropdown}>
                            Global
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </span>
                    </div>

                    <div className={classes.statsRow}>
                        <div className={classes.gaugeBox}>
                            <svg viewBox="0 0 120 120" width="104" height="104" style={{ flex: 'none' }}>
                                <circle cx="60" cy="60" r={RADIUS} fill="none" stroke="#EEF1F4" strokeWidth="11" />
                                {RING_DATA.map((r, i) => (
                                    <circle
                                        key={i}
                                        cx="60"
                                        cy="60"
                                        r={RADIUS}
                                        fill="none"
                                        stroke={r.color}
                                        strokeWidth="11"
                                        strokeDasharray={r.dash}
                                        transform={r.rotate}
                                        strokeLinecap="butt"
                                    />
                                ))}
                                <text x="60" y="48" textAnchor="middle" fontFamily="'Figtree', sans-serif" fontSize="7.5" fill="#5B6470">
                                    Overall Capability
                                </text>
                                <text x="60" y="76" textAnchor="middle" fontFamily="'Figtree', sans-serif" fontWeight="800" fontSize="30" fill="#1B2430">
                                    72
                                </text>
                                <text x="60" y="88" textAnchor="middle" fontFamily="'Figtree', sans-serif" fontSize="7.5" fill="#5B6470">
                                    /100
                                </text>
                            </svg>
                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 56, flex: 1, minWidth: 40 }}>
                                <span style={{ flex: 1, height: '30%', background: '#CFE3F5', borderRadius: 2 }} />
                                <span style={{ flex: 1, height: '42%', background: '#B9D6F0', borderRadius: 2 }} />
                                <span style={{ flex: 1, height: '55%', background: '#9CC4EA', borderRadius: 2 }} />
                                <span style={{ flex: 1, height: '68%', background: '#7FB1E3', borderRadius: 2 }} />
                                <span style={{ flex: 1, height: '82%', background: '#5F9CDB', borderRadius: 2 }} />
                                <span style={{ flex: 1, height: '100%', background: '#3C84D2', borderRadius: 2 }} />
                            </div>
                        </div>

                        <div className={classes.areasBox}>
                            {AREAS.map((a) => (
                                <div key={a.name} className={classes.areaRow}>
                                    <span className={classes.areaName}>{a.name}</span>
                                    <span className={classes.areaTrack}>
                                        <span className={classes.areaFill} style={{ width: `${a.value}%`, background: a.color }} />
                                    </span>
                                    <span className={classes.areaScore}>{a.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={classes.bottomRow}>
                        <div className={classes.benchmarkCard}>
                            <span className={classes.benchmarkTitle}>Global Benchmark</span>
                            <div aria-hidden="true" className={classes.benchmarkPlot}>
                                <span className={classes.plotDot} style={{ left: '22%', top: '30%' }} />
                                <span className={classes.plotDot} style={{ left: '48%', top: '55%' }} />
                                <span className={classes.plotDot} style={{ left: '70%', top: '36%' }} />
                                <span className={classes.plotDot} style={{ left: '84%', top: '66%' }} />
                            </div>
                            <div className={classes.benchmarkLegend}>
                                {BENCHMARK_ITEMS.map((b) => (
                                    <span key={b.label} className={classes.legendItem}>
                                        <span className={classes.legendLabel}>
                                            <span className={classes.legendDot} style={{ background: b.color }} />
                                            {b.label}
                                        </span>
                                        <strong style={{ color: '#1B2430' }}>{b.score}</strong>
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className={classes.impactCard}>
                            <div className={classes.impactLeft}>
                                <span className={classes.impactTitle}>Program Impact</span>
                                <div className={classes.impactBars}>
                                    <span style={{ flex: 1, height: '28%', background: '#CFE3F5', borderRadius: 3 }} />
                                    <span style={{ flex: 1, height: '40%', background: '#B9D6F0', borderRadius: 3 }} />
                                    <span style={{ flex: 1, height: '52%', background: '#9CC4EA', borderRadius: 3 }} />
                                    <span style={{ flex: 1, height: '66%', background: '#7FB1E3', borderRadius: 3 }} />
                                    <span style={{ flex: 1, height: '82%', background: '#5F9CDB', borderRadius: 3 }} />
                                    <span style={{ flex: 1, height: '100%', background: '#2456A4', borderRadius: 3 }} />
                                </div>
                            </div>
                            <div className={classes.impactRight}>
                                <span className={classes.impactMuted}>Last 12 months</span>
                                <span className={classes.impactMuted} style={{ marginTop: 8 }}>Completion Rate</span>
                                <span className={classes.impactValue}>+40%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PbdqHeroDashboardCard;
